<template>
  <a-modal
    v-model="visible"
    title="Détails du chèque existant"
    :footer="null"
    width="800px"
    @cancel="handleClose"
  >
    <div v-if="cheque" class="cheque-details">
      <a-alert
        message="Ce chèque existe déjà"
        type="error"
        show-icon
        style="margin-bottom: 16px"
      />

      <a-descriptions title="Informations du chèque" bordered>
        <a-descriptions-item :label="$t('recette.numCheque')" span="2">
          {{ cheque.num }}
          <a-tag
            :color="getChequeStatutColor(cheque.status)"
            class="status-tag"
          >
            {{ $t("status." + cheque.status) }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.banque')" span="2">
          {{ cheque.bank }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.titulaire')" span="2">
          {{ cheque.titulaire }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.montant')" span="2">
          {{ cheque.montant.toFixed(2) }} DT
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.dateEcheance')" span="2">
          {{
            cheque.dateEchance
              ? new Date(cheque.dateEchance).toLocaleDateString("fr-FR")
              : "--"
          }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.dateAjout')" span="2">
          {{
            cheque.createdAt
              ? new Date(cheque.createdAt).toLocaleDateString("fr-FR")
              : "--"
          }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.doneBy')" span="2">
          {{ cheque.relatedInvoice.doneBy.userName }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.stats.bankStatus')" span="2">
          <a-tag :color="getChequeStatutColor(cheque.bankStatus)">
            {{ $t("status." + cheque.bankStatus) }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('recette.type')" span="2">
          <a-tag :color="getPaymentMethodColor(cheque.type)">
            {{ cheque.type }}
          </a-tag>
        </a-descriptions-item>
      </a-descriptions>

      <div v-if="cheque.relatedInvoice" style="margin-top: 16px">
        <a-descriptions :title="$t('recette.facture')" bordered>
          <a-descriptions-item :label="$t('recette.numSerie')" span="2">
            {{ cheque.relatedInvoice.serial }}
          </a-descriptions-item>
          <a-descriptions-item
            :label="$t('recette.stats.generalStatus')"
            span="2"
          >
            <a-tag :color="getInvoiceStatusColor(cheque.relatedInvoice.status)">
              {{ $t("status." + cheque.relatedInvoice.status) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="Caisse" span="2">
            {{ cheque.relatedInvoice.caisse.name || "--" }}
          </a-descriptions-item>
        </a-descriptions>
      </div>

      <div v-if="cheque.note" style="margin-top: 16px">
        <a-descriptions title="Note" bordered>
          <a-descriptions-item label="Commentaire" span="3">
            {{ cheque.note }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {
  getChequeStatutColor,
  getPaymentMethodColor,
  getInvoiceStatusColor,
} from "@/utilities/settings";

export default {
  name: "ChequeVerifyModal",

  components: {},

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    cheque: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {};
  },

  methods: {
    getChequeStatutColor,
    getPaymentMethodColor,
    getInvoiceStatusColor,

    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cheque-details {
  max-height: 500px;
  overflow-y: auto;
}

.cheque-details .ant-descriptions-item-label {
  font-weight: 600;
  color: #262626;
}

.cheque-details .ant-descriptions-item-content {
  color: #595959;
}

.cheque-details .ant-tag {
  font-weight: 500;
  border-radius: 4px;
}

.status-tag {
  margin-left: 8px;
}
</style>
